<template>
  <div id="mecanizado-history-data">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs12 md4>
          <v-card max-width="100%" height="280">
            <v-card-text>Año: 2019</v-card-text>
            <v-card-text>Establecimiento: {{ this.nombreEstab }} </v-card-text>
            <v-card-text>Nivel: {{ this.nivel }}</v-card-text>
            <v-card-text>Tipo Prueba: {{ this.tipoPrueba }} </v-card-text>
          </v-card>
          <br />
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <template>
        <v-data-table
          :headers="headers"
          :items="itemsAlumnos"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          @page-count="pageCount = $event"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
            <td class="text-xs-left">{{ props.item.numeroLista }}</td>
            <td class="text-xs-left">{{ props.item.run }}</td>
            <td class="text-xs-left">{{ props.item.dvRun }}</td>
            <td class="text-xs-left">
              {{
                props.item.aluNombres +
                " " +
                props.item.aluPaterno +
                " " +
                props.item.aluMaterno
              }}
            </td>
            <td class="text-xs-left">{{ props.item.sexo }}</td>
          </template>
        </v-data-table>
      </template>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn :loading="loading" color="primary" @click="descargaMasiva()"
          >Descarga <v-icon right dark>folder</v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import axios from "axios";
import { error } from "util";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "mecanizado-history-data",
  components: {
    LoadingDescarga,
  },
  mixins: [misMixins, validationMixin],

  props: {
    tipeView: "",
  },
  data() {
    return {
      dialogLoading: false,
      totalRegistro: "",
      rowsPerPageItems: [50],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
      headers: [
        { text: "Código Curso", align: "left", sortable: false, value: "rut" },
        { text: "Número Lista", sortable: false, value: "candidato" },
        { text: "Run", sortable: false, value: "evaluacion" },
        { text: "Dv Run", sortable: false, value: "fecha" },
        { text: "Nombre Apellidos", sortable: false, value: "fecha" },
        { text: "Sexo", sortable: false, value: "fecha" },
      ],
      itemsAlumnos: [],
      descripcion: "",
      fechaModificacion: "",
      username: "",
      menu1: false,
      botonDescarga: false,
      usuarioLoggedTipe: "",
      nivel: "",
      tipoPrueba: "",
      nombreEstab: "",
      codigoCurso: "",
    };
  },

  computed: {},

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.nivel = this.$route.params.nivel;
    this.nombreEstab = this.$route.params.nombreEstab;
    this.codigoCurso = this.$route.params.codigoCurso;

    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    submit() {
      this.$v.$touch();
    },
    volver() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },

    async loadCapturaFilter() {
      return await axios
        .get("/empadronamiento/alumnos/curso/" + this.codigoCurso)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsAlumnos = await this.loadCapturaFilter();

      if (this.itemsAlumnos.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    async descargaMasiva() {
      this.dialogLoading = true;
      this.res = await this.descarga();
      this.dialogLoading = false;
    },
    async descarga() {
      return await axios
        .get("empadronamiento/alumnos/download/" + this.codigoCurso, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute(
            "download",
            "DESCARGA_ALUMNOS_EMPADRONAMIENTO.xlsx"
          );
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
